/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const AccountUpdateRequest = zod.strictObject({
    name: zod.string().min(1),
    user_manual_path: zod.string().nullish(),
    forum_path: zod.string().nullish(),
    modules: zod
        .array(
            zod
                .enum([
                    'DATA_COLLECTION_FORMS',
                    'DEFAULT',
                    'DHIS2_MAPPING',
                    'EMBEDDED_LINKS',
                    'ENTITIES',
                    'EXTERNAL_STORAGE',
                    'PLANNING',
                    'POLIO_PROJECT',
                    'REGISTRY',
                    'PAYMENTS',
                    'COMPLETENESS_PER_PERIOD',
                    'TRYPELIM_PROJECT',
                    'DATA_VALIDATION',
                    'SAAS',
                    'STOCK_MANAGEMENT',
                    'SNT_MALARIA',
                    'FORM_AI',
                    'VALIDATION_WORKFLOW',
                ])
                .describe(
                    '\* `DATA_COLLECTION_FORMS` - Data collection - Forms\n\* `DEFAULT` - Default\n\* `DHIS2_MAPPING` - DHIS2 mapping\n\* `EMBEDDED_LINKS` - Embedded links\n\* `ENTITIES` - Entities\n\* `EXTERNAL_STORAGE` - External storage\n\* `PLANNING` - Planning\n\* `POLIO_PROJECT` - Polio project\n\* `REGISTRY` - Registry\n\* `PAYMENTS` - Payments\n\* `COMPLETENESS_PER_PERIOD` - Completeness per Period\n\* `TRYPELIM_PROJECT` - Trypelim project\n\* `DATA_VALIDATION` - Change requests\n\* `SAAS` - SaaS\n\* `STOCK_MANAGEMENT` - Stock management\n\* `SNT_MALARIA` - SNT Malaria\n\* `FORM_AI` - Form AI\n\* `VALIDATION_WORKFLOW` - Validation workflow',
                ),
        )
        .nullish(),
    enforce_password_validation: zod.boolean().optional(),
    custom_translations: zod.unknown().nullish(),
    feature_flags: zod.array(zod.string().min(1).nullable()).optional(),
});

export type AccountUpdateRequest = zod.input<typeof AccountUpdateRequest>;
export type AccountUpdateRequestOutput = zod.output<
    typeof AccountUpdateRequest
>;
